export default "__VITE_PUBLIC_ASSET__ec1f3129__"